import { reactive } from 'vue';

export const useModals = () => {
  const modals = reactive({
    isQuestionFormOpen: false,
    isQuestionSuccessOpen: false,
    isDemoFormOpen: false,
    isPreOrderFormOpen: false,
    isViewFormModalOpen: false,

    openQuestionForm() {
      modals.isQuestionFormOpen = true;
    },
    closeQuestionForm() {
      modals.isQuestionFormOpen = false;
    },
    openQuestionSuccess() {
      modals.isQuestionSuccessOpen = true;
    },
    closeQuestionSuccess() {
      modals.isQuestionSuccessOpen = false;
    },
    openDemoForm() {
      modals.isDemoFormOpen = true;
    },
    closeDemoForm() {
      modals.isDemoFormOpen = false;
    },
    openPreOrderForm() {
      modals.isPreOrderFormOpen = true;
    },
    closePreOrderForm() {
      modals.isPreOrderFormOpen = false;
    },
    openViewForm() {
      modals.isViewFormModalOpen = true;
    },
    closeViewForm() {
      modals.isViewFormModalOpen = false;
    },
  });

  return modals;
};
